import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { MEDIA } from "@/lib/church";
import { Play, MusicNote, VideoCamera, CalendarBlank, User } from "@phosphor-icons/react";

export default function Sermons() {
    const [sermons, setSermons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [active, setActive] = useState(null);

    useEffect(() => {
        api.get("/sermons").then((r) => setSermons(r.data)).catch(() => {}).finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="sermons-page" className="bg-white">
            <section className="relative min-h-[60vh] flex items-end overflow-hidden bg-[#4C1D95]">
                <div className="absolute inset-0">
                    <img src={MEDIA.pastorBible} alt="Sermons" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#4C1D95]/95 via-[#4C1D95]/65 to-[#4C1D95]/20" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#4C1D95]/80 via-transparent to-transparent" />
                </div>
                <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 w-full">
                    <p className="overline text-[#FFC72C] mb-4 animate-fade-up">Listen & Watch</p>
                    <h1 className="font-display text-6xl sm:text-7xl lg:text-7xl font-bold tracking-tight text-white leading-[0.85] animate-fade-up animate-delay-100" data-testid="sermons-title">
                        Sermons that speak<br />
                        to <span className="text-[#FFC72C] italic">today</span>.
                    </h1>
                </div>
            </section>

            {/* FEATURED SERMONS */}
            <section className="bg-[#F8F5F0] py-16 lg:py-24" data-testid="featured-sermon-section">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12 lg:mb-16">
                        <div className="inline-flex items-center gap-3 mb-4">
                            <span className="w-10 h-px bg-[#4C1D95]" />
                            <p className="overline text-[#4C1D95]">Featured Sermons</p>
                            <span className="w-10 h-px bg-[#4C1D95]" />
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#2E1A47] leading-[0.95] mb-4">
                            Messages from <span className="italic text-[#4C1D95]">Pastor Woods</span>.
                        </h2>
                    </div>

                    <div className="space-y-16 lg:space-y-20">
                        {[
                            {
                                id: "still-in-love",
                                titleLead: "Are You Still",
                                titleAccent: "In Love?",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/b8iyojxf_Are%20You%20Still%20IN%20Love_%20_%20A%20Pastor%20Woods%20Sermon_1080p.mp4",
                            },
                            {
                                id: "spirit-of-maybe",
                                titleLead: "The Spirit of Maybe",
                                titleAccent: "Climb the Mountain",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/msrjfkcs_The%20Spirit%20of%20Maybe%20_%20Climb%20the%20Mountain%20v2_1080p.mp4",
                            },
                            {
                                id: "hagars-story",
                                titleLead: "The Beginning and The End",
                                titleAccent: "Hagar's Story",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/rdn9t1an_The%20Beginning%20and%20The%20End_%20Hagar%27s%20Story_1080p.mp4",
                            },
                            {
                                id: "right-name-wrong-relationship",
                                titleLead: "Right Name,",
                                titleAccent: "Wrong Relationship",
                                subtitle: "Acts 19 · A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/pr0dg5ot_Right%20Name%2C%20Wrong%20Relationship%20_%20Acts%2019%20Sermon%20v2_1080p.mp4",
                            },
                            {
                                id: "seeking-the-kingdom-first",
                                titleLead: "Seeking the Kingdom First",
                                titleAccent: "Competing Kingdoms",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/5vc656s0_Seeking%20the%20Kingdom%20First%20_%20Competing%20Kingdoms%20_%20Pastor%20Woods%20v5_1080p.mp4",
                            },
                            {
                                id: "era-of-errors",
                                titleLead: "The Era of Errors",
                                titleAccent: "Condensed",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/yz5wsc1l_The%20Era%20of%20Errors%20%28Condensed%29%20-%20Pastor%20Woods_1080p.mp4",
                            },
                            {
                                id: "revealed-kingdom",
                                titleLead: "The",
                                titleAccent: "Revealed Kingdom",
                                subtitle: "A message from Pastor Marlo Woods, M.Div.",
                                src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_olive-worship/artifacts/73h4o9bo_The%20Revealed%20Kingdom%20_%20Pastor%20Woods%20Sermon%20v12_1080p.mp4",
                            },
                        ].map((v) => (
                            <div key={v.id} data-testid={`featured-sermon-${v.id}`}>
                                <div className="text-center mb-6">
                                    <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-[#2E1A47] leading-[0.95] mb-3" data-testid={`featured-sermon-title-${v.id}`}>
                                        {v.titleLead} <span className="italic text-[#4C1D95]">{v.titleAccent}</span>
                                    </h3>
                                    <p className="text-slate-600 text-sm lg:text-base">{v.subtitle}</p>
                                </div>
                                <div className="relative">
                                    <div className="absolute -inset-1 lg:-inset-2 bg-[#FFC72C]" aria-hidden="true" />
                                    <div className="relative bg-black shadow-[0_35px_80px_-15px_rgba(76,29,149,0.35)] aspect-video">
                                        <video
                                            controls
                                            preload="metadata"
                                            playsInline
                                            data-testid={`featured-sermon-player-${v.id}`}
                                            className="absolute inset-0 w-full h-full object-contain bg-black"
                                            src={v.src}
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                                <div className="mt-6 flex flex-wrap items-center justify-center gap-6 text-sm text-slate-600">
                                    <span className="flex items-center gap-2"><User size={14} weight="bold" className="text-[#4C1D95]" /> Rev. Marlo Woods, M.Div.</span>
                                    <span className="hidden sm:inline text-slate-300">·</span>
                                    <span className="flex items-center gap-2"><VideoCamera size={14} weight="bold" className="text-[#4C1D95]" /> Full-length video</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-white py-20 lg:py-28">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {active && (
                        <div className="mb-12 bg-[#4C1D95] text-white p-6 lg:p-10" data-testid="active-sermon-player">
                            <div className="flex items-start justify-between gap-6 mb-4">
                                <div>
                                    <p className="overline text-[#FFC72C] mb-2">Now Playing</p>
                                    <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight leading-tight">{active.title}</h2>
                                    <p className="text-sm text-white/70 mt-2">{active.preacher} · {new Date(active.date).toLocaleDateString("en-US", { dateStyle: "long" })}</p>
                                </div>
                                <button type="button" onClick={() => setActive(null)} data-testid="close-player-btn" className="text-white/70 hover:text-white text-xs uppercase tracking-widest font-bold">Close</button>
                            </div>
                            {active.media_type === "video" ? (
                                <video controls className="w-full max-h-[70vh] bg-black" src={`${API}/sermons/${active.id}/stream`} data-testid="video-player" />
                            ) : (
                                <audio controls className="w-full" src={`${API}/sermons/${active.id}/stream`} data-testid="audio-player" />
                            )}
                            {active.description && <p className="text-white/80 mt-4 leading-relaxed">{active.description}</p>}
                        </div>
                    )}

                    {loading ? (
                        <p className="text-slate-500">Loading sermons...</p>
                    ) : sermons.length === 0 ? null : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {sermons.map((s) => (
                                <button
                                    type="button"
                                    key={s.id}
                                    onClick={() => setActive(s)}
                                    data-testid={`sermon-card-${s.id}`}
                                    className="group text-left bg-white border border-slate-200 hover:border-[#4C1D95] hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 p-8 flex flex-col"
                                >
                                    <div className="flex items-center gap-3 mb-6">
                                        <span className={`w-12 h-12 flex items-center justify-center ${s.media_type === "video" ? "bg-[#FFC72C] text-[#2E1A47]" : "bg-[#4C1D95] text-white"}`}>
                                            {s.media_type === "video" ? <VideoCamera size={22} weight="bold" /> : <MusicNote size={22} weight="bold" />}
                                        </span>
                                        <span className="text-[10px] uppercase tracking-widest text-slate-500 font-black">{s.media_type}</span>
                                    </div>
                                    <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-[#2E1A47] mb-3 leading-tight">{s.title}</h3>
                                    <div className="text-sm text-slate-500 space-y-1 mb-4">
                                        <p className="flex items-center gap-2"><User size={14} weight="bold" /> {s.preacher}</p>
                                        <p className="flex items-center gap-2"><CalendarBlank size={14} weight="bold" /> {new Date(s.date).toLocaleDateString("en-US", { dateStyle: "long" })}</p>
                                    </div>
                                    {s.description && <p className="text-sm text-slate-600 leading-relaxed line-clamp-3 mb-6">{s.description}</p>}
                                    <span className="mt-auto inline-flex items-center gap-2 text-xs uppercase tracking-widest font-black text-[#4C1D95] group-hover:gap-3 transition-all">
                                        <Play size={14} weight="fill" /> Play
                                    </span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
